var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("img", {
    class: _vm.mergedClass,
    style: _vm.mergedStyle,
    attrs: { src: _vm.url, alt: _vm.alt }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }